import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Utils } from '../../../shared/utils';
import * as FileSaver from 'file-saver';
import { AccountingAccountsListComponent } from '../accounting-accounts/accounting-accounts-list.component';
import { AccountingMovementsService } from '../movements/accounting-movements.service';
import { UntypedFormControl, Validators } from '@angular/forms';

@Component({
    selector: 'convfact-accounting-imbalance',
    templateUrl: './accounting-imbalance-dialog.component.html',
    styleUrls: [],
    standalone: false
})

export class AccountingImbalanceDialogComponent {

  public fromDate: UntypedFormControl;

  public error: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<AccountingAccountsListComponent>,
    public snackBar: MatSnackBar,
    public accountingMovementsService: AccountingMovementsService
  ) {
    const initialDate = new Date(new Date().getFullYear(), 0, 1);

    this.fromDate = new UntypedFormControl(initialDate, [Validators.required])
  }

  public downloadAccountingImbalence(): void {
    this.accountingMovementsService.excelAccountingImbalance(this.fromDate.value)
      .then(response => {
        FileSaver.saveAs(response, Utils.GetExcelName("Descuadres"));
        this.error = false;
      }).catch(err => {
        this.error = true;
      });
  }

  public close(): void {
    this.dialogRef.close();
  }

}
